<template>
  <div id="app">
    <Portal/>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import Portal from './components/Portal.vue'

export default {
  name: 'App',
  components: {
    // HelloWorld
    Portal
  }
}
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}

html, body, #cesiumContainer {
    width: 100%;
    height: 94vh;
    margin: 0;
    padding: 0;
    /* overflow: hidden; */
    background: #000;
}
</style>
